import QNA from './QNA';

export default QNA
export { QNA as Base }
